import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "van-safe-area-bottom"
}, null, -1);

import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import TabBarLight from '@/components/TabBarLight.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'TabBar',

  setup(__props) {
    const tabBarList = [{
      icon: 'shouyeweixuanzhong',
      activeIcon: 'shouyexuanzhong',
      title: '首页',
      to: '/'
    }, {
      icon: 'yuyueweixuanzhong',
      activeIcon: 'yuyuexuanzhong',
      title: '预约',
      to: '/appointment'
    }, {
      icon: 'fuwuweixuanzhong',
      activeIcon: 'fuwuxuanzhong',
      title: '服务',
      to: '/service'
    }, {
      icon: 'wodeweixuanzhong',
      activeIcon: 'wode-xuanzhong',
      title: '我的',
      to: '/my'
    }];
    const active = ref(0);
    const isShow = ref(true);
    const route = useRoute();
    watch(() => route.path, val => {
      const index = tabBarList.findIndex(item => item.to === val);
      isShow.value = index > -1 ? true : false;
      active.value = index;
    });
    return (_ctx, _cache) => {
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");

      const _component_van_tabbar = _resolveComponent("van-tabbar");

      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, isShow.value ? (_openBlock(), _createBlock(_component_van_tabbar, {
        key: 0,
        class: "tabbar-wrap",
        "active-color": "#29241A",
        "inactive-color": "#7D7A74",
        "z-index": "666",
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        placeholder: ""
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabBarList, (item, index) => {
          return _createVNode(_component_van_tabbar_item, {
            key: item.to,
            icon: active.value == index ? item.activeIcon : item.icon,
            "icon-prefix": "icon",
            class: "iconfont",
            to: item.to
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["icon", "to"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])) : (_openBlock(), _createBlock(TabBarLight, {
        key: 1
      }))], 64);
    };
  }

});